<div class="header text-center">
  <div class="bottom">
    <div class="logo">
      <img
        [ngStyle]="{
          'border-radius':
            hospitalDetails.logoShape === 'rounded' ? '50%' : '0%',
          width: '100px',
          height: '100px',
          'object-fit': 'cover'
        }"
        [src]="hospitalDetails?.logo"
        alt="Hospital Logo"
      />
    </div>
    <div class="div">
      <small
        [ngStyle]="{
          color: hospitalDetails.otherTitleColor,
        }"
        [ngClass]="
          hospitalDetails.otherTitleWeight === 'bold'
            ? 'bold-text-otherTitle'
            : 'normal-text-otherTitle'
        "
        >{{ hospitalDetails?.otherTitle }}</small
      >
      <div
        class="hospital-name"
        [ngStyle]="{
          'color': hospitalDetails.mainTitleColor,
       
        }"
        [ngClass]="
          hospitalDetails.mainTitleWeight === 'bold'
            ? 'bold-text-mainTitle'
            : 'normal-text-mainTitle'
        "
      >
        {{ hospitalDetails?.mainTitle }}
      </div>
      <div
        class="hospital-address"
        [ngStyle]="{
          'color': hospitalDetails.addressColor,
        }"
        [ngClass]="
          hospitalDetails.addressWeight === 'bold'
            ? 'bold-text-address'
            : 'normal-text-address'
        "
      >
        {{ hospitalDetails?.address }}
      </div>
      <div
        class="hospital-contact"
        [ngStyle]="{
          color: hospitalDetails.phoneColor,
        }"
        [ngClass]="
          hospitalDetails.phoneWeight === 'bold'
            ? 'bold-text-contact'
            : 'normal-text-contact'
        "
      >
        Contact: {{ hospitalDetails?.phone }}
      </div>
    </div>
    <div class="logo">
      <img
        [ngStyle]="{
          'border-radius':
            hospitalDetails.logoShape === 'rounded' ? '50%' : '0%',
          width: '100px',
          height: '100px',
          'object-fit': 'cover'
        }"
        [src]="hospitalDetails?.logo"
        alt="Hospital Logo"
      />
    </div>
  </div>
</div>
